module.exports = __webpack_public_path__ + "img/wts_img.a85d5d7f.png";